export const navLinks = [
  { label: '首页', href: '/' },
  { label: '课程体系', href: '/courses' },
  { label: '价格方案', href: '/#pricing' },
  { label: '学员评价', href: '/#testimonials' },
  { label: '关于我们', href: '/#about' },
];

export const heroSlides = [
  {
    title: 'AI 人才培养套餐',
    subtitle: '三大阶梯式课程体系，从零基础到全栈AI工程师，限时优惠最高省 ¥400',
    cta: '查看套餐',
    secondaryLabel: '了解课程详情',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20warm%20abstract%20composition%20with%20flowing%20golden%20amber%20and%20cream%20gradients%2C%20luminous%20glass-like%20geometric%20layers%20with%20soft%20depth%2C%20sophisticated%20tech%20education%20mood%2C%20gentle%20radiant%20light%20beams%20from%20upper%20left%2C%20rich%20golden%20highlights%20against%20deep%20cream%20backdrop%2C%20luxurious%20minimal%20modern%20art%20style%2C%20no%20text%20no%20people&width=1600&height=900&seq=hero-slide-v2-01&orientation=landscape',
  },
  {
    title: '实战驱动，项目为王',
    subtitle: '20+真实企业级项目实战，从数据清洗到模型部署全流程覆盖，结业即拥有完整AI作品集',
    cta: '立即报名',
    secondaryLabel: '免费试听',
    image: 'https://readdy.ai/api/search-image?query=Warm%20minimalist%20abstract%20composition%20with%20layered%20translucent%20geometric%20shapes%20in%20soft%20golden%20amber%20and%20cream%20tones%2C%20gentle%20flowing%20curves%20blending%20with%20structured%20grid%20elements%2C%20elegant%20modern%20art%20with%20depth%20and%20sophistication%2C%20warm%20lighting%20and%20airy%20feel%2C%20no%20text%2C%20editorial%20photography%20style&width=1600&height=900&seq=hero-slide-v2-02&orientation=landscape',
  },
  {
    title: '名师一对一指导',
    subtitle: '来自BAT等顶尖科技公司的AI专家亲自授课，全程答疑辅导，助你快速突破技术瓶颈',
    cta: '了解导师',
    secondaryLabel: '课程大纲',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20abstract%20art%20with%20warm%20golden%20honey%20and%20cream%20tones%2C%20soft%20circular%20forms%20overlapping%20with%20delicate%20linear%20elements%2C%20subtle%20warm%20gradient%20transitions%2C%20minimalist%20sophisticated%20composition%2C%20light%20and%20airy%20atmosphere%20with%20gentle%20texture%2C%20no%20text%2C%20editorial%20fine%20art%20quality&width=1600&height=900&seq=hero-slide-v2-03&orientation=landscape',
  },
];

export const courses = [
  {
    id: 'ai-basics',
    title: 'AI基础入门班',
    tag: '零基础友好',
    description: '从Python编程基础到机器学习入门，适合没有任何AI经验的学员。30天系统学习，建立扎实的AI知识体系。',
    image: 'https://readdy.ai/api/search-image?query=Clean%20modern%20minimalist%20coding%20workspace%20with%20warm%20ambient%20lighting%2C%20laptop%20displaying%20abstract%20code%20patterns%2C%20notebook%20and%20coffee%20on%20wooden%20desk%2C%20soft%20cream%20and%20warm%20amber%20accents%2C%20elegant%20editorial%20photography%20style%2C%20calm%20focused%20atmosphere%2C%20no%20text&width=800&height=500&seq=course-basics&orientation=landscape',
    price: 399,
    duration: '4周',
    students: 3256,
    features: ['Python编程基础', '数据分析入门', '机器学习原理', '实战小项目'],
  },
  {
    id: 'ml-practical',
    title: '机器学习实战班',
    tag: '最受欢迎',
    description: '深入掌握监督学习、无监督学习、特征工程等核心技能，通过10个真实项目积累实战经验。',
    image: 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20data%20science%20workspace%20with%20warm%20golden%20lighting%2C%20multiple%20screens%20showing%20data%20visualizations%20and%20charts%2C%20clean%20wooden%20desk%20setup%2C%20soft%20cream%20and%20amber%20tones%2C%20elegant%20editorial%20photography%2C%20sophisticated%20professional%20atmosphere%2C%20no%20text&width=800&height=500&seq=course-ml&orientation=landscape',
    price: 699,
    duration: '8周',
    students: 2189,
    features: ['监督学习算法', '特征工程', '模型评估优化', '10个实战项目'],
  },
  {
    id: 'dl-advanced',
    title: '深度学习进阶班',
    tag: '进阶提升',
    description: '深入学习神经网络、CNN、RNN、Transformer等前沿技术，掌握PyTorch和TensorFlow框架。',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20tech%20workspace%20with%20warm%20ambient%20light%2C%20neural%20network%20abstract%20visualization%20on%20large%20screen%2C%20clean%20modern%20desk%20with%20notebooks%2C%20soft%20cream%20and%20golden%20amber%20palette%2C%20sophisticated%20editorial%20photography%20style%2C%20calm%20focused%20environment%2C%20no%20text&width=800&height=500&seq=course-dl&orientation=landscape',
    price: 999,
    duration: '12周',
    students: 1567,
    features: ['神经网络架构', 'CNN/RNN/Transformer', 'PyTorch实战', '模型部署上线'],
  },
];

export const pricingPlans = [
  {
    name: '基础入门',
    price: 399,
    originalPrice: 599,
    period: '一次性',
    features: [
      'AI基础入门班全部内容',
      '30天无限次回看',
      '社群答疑支持',
      '结业证书',
      '1个实战项目',
    ],
    highlighted: false,
  },
  {
    name: '专业进阶',
    price: 699,
    originalPrice: 999,
    period: '一次性',
    features: [
      '基础+实战两门课程',
      '90天无限次回看',
      '一对一导师辅导',
      '专属学习社群',
      '10个实战项目',
      '简历优化指导',
      '模拟面试',
    ],
    highlighted: true,
  },
  {
    name: '全栈大师',
    price: 999,
    originalPrice: 1399,
    period: '一次性',
    features: [
      '全部三门课程',
      '终身无限次回看',
      '顶级导师1v1指导',
      'VIP学习社群',
      '20+实战项目',
      '就业推荐服务',
      '名企内推机会',
      'AI工程师认证',
      '免费更新课程',
    ],
    highlighted: false,
  },
];

export const testimonials = [
  {
    name: '张伟',
    role: '前产品经理，现AI工程师',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20Asian%20male%20in%20his%2030s%2C%20warm%20friendly%20expression%2C%20clean%20cream%20background%2C%20business%20casual%20attire%2C%20soft%20natural%20lighting%2C%20professional%20corporate%20photography%20style&width=120&height=120&seq=avatar-01&orientation=squarish',
    content: '从零基础开始学习，三个月后成功转行AI工程师，薪资翻了一倍！课程内容非常系统，老师讲解清晰，项目实战让我积累了宝贵的经验。',
    rating: 5,
  },
  {
    name: '李明珠',
    role: '数据分析师',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20Asian%20female%20in%20her%20late%2020s%2C%20confident%20smile%2C%20clean%20cream%20background%2C%20modern%20business%20attire%2C%20soft%20natural%20lighting%2C%20professional%20corporate%20photography%20style&width=120&height=120&seq=avatar-02&orientation=squarish',
    content: '机器学习实战班真的物超所值！每个项目都贴近真实业务场景，学完直接就能用到工作中。导师的答疑非常及时，学习体验特别好。',
    rating: 5,
  },
  {
    name: '王浩然',
    role: '计算机专业研究生',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20Asian%20male%20in%20his%20mid%2020s%2C%20friendly%20genuine%20smile%2C%20clean%20cream%20background%2C%20casual%20smart%20attire%2C%20soft%20natural%20lighting%2C%20professional%20photography%20style&width=120&height=120&seq=avatar-03&orientation=squarish',
    content: '深度学习进阶班帮我打开了AI研究的大门，Transformer和LLM的内容非常前沿。导师来自大厂，分享了很多工业界的实战经验。',
    rating: 5,
  },
  {
    name: '陈思雨',
    role: '市场营销总监',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20Asian%20female%20in%20her%2030s%2C%20warm%20professional%20smile%2C%20clean%20cream%20background%2C%20elegant%20business%20attire%2C%20soft%20natural%20lighting%2C%20professional%20corporate%20photography%20style&width=120&height=120&seq=avatar-04&orientation=squarish',
    content: '作为非技术背景的学员，AI基础入门班让我真正理解了人工智能。现在我能和技术团队高效沟通，还能用AI工具提升营销效率。',
    rating: 5,
  },
  {
    name: '刘志远',
    role: '创业公司CTO',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20Asian%20male%20in%20his%2030s%2C%20confident%20expression%2C%20clean%20cream%20background%2C%20smart%20casual%20attire%2C%20soft%20natural%20lighting%2C%20professional%20corporate%20photography%20style&width=120&height=120&seq=avatar-05&orientation=squarish',
    content: '全栈大师班让我团队的技术实力整体提升了一个档次。课程体系非常完整，从理论到实践再到部署，每个环节都经过精心设计。',
    rating: 5,
  },
  {
    name: '赵晓琳',
    role: '应届毕业生',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20Asian%20female%20in%20her%20early%2020s%2C%20bright%20genuine%20smile%2C%20clean%20cream%20background%2C%20modern%20casual%20attire%2C%20soft%20natural%20lighting%2C%20professional%20photography%20style&width=120&height=120&seq=avatar-06&orientation=squarish',
    content: '通过全栈大师班的学习和就业推荐服务，毕业前就拿到了心仪的AI岗位offer。课程的项目经历在面试中起到了决定性作用！',
    rating: 5,
  },
];

export const heroPackages = {
  title: 'AI 人才培养套餐',
  subtitle: '三大阶梯式课程体系，从零基础到全栈AI工程师，限时优惠最高省 ¥6,000',
};

export const footerLinks = {
  courses: [
    { label: 'AI基础入门班', href: '/courses#ai-basics' },
    { label: '机器学习实战班', href: '/courses#ml-practical' },
    { label: '深度学习进阶班', href: '/courses#dl-advanced' },
  ],
  company: [
    { label: '关于我们', href: '/#about' },
    { label: '联系我们', href: '/contact' },
    { label: '加入我们', href: '/contact' },
  ],
  legal: [
    { label: '退款政策', href: '/refund-policy' },
    { label: '服务条款', href: '/terms' },
    { label: '隐私政策', href: '/terms' },
  ],
};